import { client } from "../../api/client"
import { getAttachmentById } from "../../features/tickets/data/localTicketAttachmentStore"

export const fetchTicketAttachmentById = async (id) => {
    // If using local data, return the attachment from the local store. This prevents
    // crashes if we get an unexpected SignalR notification (we shouldn't, but...)
    if (process.env.REACT_APP_USELOCALDATA === "true") {
        return getAttachmentById(id)
    }

    var uri = "autotaskapi/ticketattachments/" + id
    var responseAutotask = await client.get(uri)
    return responseAutotask.data
}